export default "__VITE_ASSET__BX5$PpQ5__"